import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const COOKIE = "googtrans";
let patched = false;

// Keeps React working when the page translator swaps text nodes.
const patchDom = () => {
  if (patched) return;
  patched = true;
  const remove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) return child;
    return remove.call(this, child);
  };
  const insert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (node, ref) {
    if (ref && ref.parentNode !== this) return node;
    return insert.call(this, node, ref);
  };
};

const setCookie = (val) => {
  const host = window.location.hostname;
  const exp = val ? "" : "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  document.cookie = `${COOKIE}=${val}; path=/${exp}`;
  document.cookie = `${COOKIE}=${val}; path=/; domain=${host}${exp}`;
};

const currentCookie = () => (document.cookie.match(/(?:^|; )googtrans=([^;]*)/) || [])[1] || "";

const loadWidget = () => {
  if (document.getElementById("gt-script")) return;
  window.googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement({ pageLanguage: "en", autoDisplay: false }, "google_translate_element");
  };
  const s = document.createElement("script");
  s.id = "gt-script";
  s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  document.body.appendChild(s);
};

export const SiteTranslator = () => {
  const { config, onboarding } = useAuth();
  const code = onboarding?.profile?.language;
  const site = config?.languages?.find((l) => l.id === code)?.site || "en";

  useEffect(() => {
    if (!config) return;
    const want = site === "en" ? "" : `/en/${site}`;
    const had = currentCookie();
    if (want) {
      patchDom();
      if (had !== want) setCookie(want);
      loadWidget();
      if (had && had !== want) window.location.reload();
    } else if (had && onboarding) {
      setCookie("");
      window.location.reload();
    }
  }, [config, site, onboarding]);

  return <div id="google_translate_element" className="hidden" aria-hidden="true" />;
};
